/**
 * WorkflowStepper — the shared Dynamic-Island stepper for every Class C/D
 * (Transaction / Workflow) BO (BO UI Standard §5).  Docked in the shell's top
 * banner (see layouts/banner.tsx).  States: done (green + ✓), active (orange),
 * to-do (grey).  One stepper, reused — never a per-form step row.
 */
import type { ReactNode } from 'react';
import './WorkflowStepper.css';

export interface WorkflowStep {
  /** Step caption.  A leading "N. " is stripped (the circle shows the number). */
  label: string;
}

interface Props {
  steps: WorkflowStep[];
  /** Index of the current step; earlier steps render "done", later "to-do". */
  activeIdx: number;
  /** Optional right-aligned actions (e.g. Reset / Load on the title row). */
  right?: ReactNode;
}

export function WorkflowStepper({ steps, activeIdx, right }: Props) {
  return (
    <div className="wfstep-bar">
      <div className="wfstep-track">
        {steps.map((s, i) => {
          const state = i < activeIdx ? 'done' : i === activeIdx ? 'active' : 'todo';
          const text = s.label.replace(/^\s*\d+\.\s*/, '');
          return (
            <div className={`wfstep wfstep-${state}`} key={s.label}>
              <span className="wfstep-num">{state === 'done' ? <i className="ti ti-check" /> : i + 1}</span>
              <span className="wfstep-lbl">{text}</span>
            </div>
          );
        })}
      </div>
      {right && <div className="wfstep-right">{right}</div>}
    </div>
  );
}
